import React from 'react';
import { Panel, Glyphicon } from 'react-bootstrap';
import { connect } from 'react-redux';
import {
    getSettings,
    updateSettings,
    clearUpdateSettings,
} from '../../../actions/settings';
import { Table } from './Table'

import { counter as counterType } from '../../../constants/settingTypes';
import { sms as smsType } from '../../../constants/settingTypes';

import EditModal from './EditModal';
import * as permissions from '../../../constants/permissions';
let SmsLimit = class extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showAddModal: false,
            showUpdateModal: false,
            confirmModalShow: false,
            smsLimitEdit: null,
        }
        this._load = this._load.bind(this);
        this._loadLimit = this._loadLimit.bind(this);
        this._onEditLimitClick = this._onEditLimitClick.bind(this);
        this._onClose = this._onClose.bind(this);
        this._updateSmsLimit = this._updateSmsLimit.bind(this);
        this._resetCountersForRegistration = this._resetCountersForRegistration.bind(this);
        
    }
    componentDidMount() {
        this._load();
        this._loadLimit();
    }
    _load() {
        this.props.getSettings(counterType);
    }
    _resetCountersForRegistration(countersForRegistration){
        this.props.updateSettings(counterType,undefined,countersForRegistration,undefined);
    }

    _loadLimit() {
        this.props.getSettings(smsType);
         
     }
    _onEditLimitClick()
    {
        this.setState({smsLimitEdit: this.props.smsLimit.data, showAddModal: true });
    }
    _updateSmsLimit(limit){
       this.props.updateSettings(smsType,limit,undefined,undefined);
    }
    _onClose() {
    this.setState({
        showAddModal: false,
    });
    this.props.clearUpdateSettings(smsType);
    }

    render() {
        const { countersForRegistrations: { data, fetching }} = this.props;
        const { showAddModal , smsLimitEdit} = this.state;
        const isReadOnly = !permissions.isAllowedFor(permissions.allowedEditSettings);
        const addByttonClass = `add-glyph${isReadOnly ? '.disabled' : ''}`;
        const modalProps = {
            initialValues: smsLimitEdit,
            onClose: this._onClose,
            onSubmit: this._updateSmsLimit
        }
        return (
            <Panel>
                <Panel.Heading >
                    <span>Ограничения смс </span>
                    <Glyphicon
                        glyph='cog'
                        title='Изменить лимит'
                        className={addByttonClass} style={{ float: 'right' }}
                        onClick={isReadOnly ? undefined : this._onEditLimitClick} />
                </Panel.Heading>
                <Panel.Body className='box-container'>
                    <Table
                        fetching={fetching}
                        countersForRegistrations={data}
                        onEdit={this._resetCountersForRegistration}
                        isReadOnly={isReadOnly} />
                 {(showAddModal ) && <EditModal {...modalProps} />}
                 
                </Panel.Body>
            </Panel>
        );
    }
}
SmsLimit = connect(state => {
    return { 
        countersForRegistrations: state.application.get('settings')[counterType],
        smsLimit: state.application.get('settings')[smsType],
    };
}, { getSettings, updateSettings, clearUpdateSettings,})(SmsLimit);
export default SmsLimit;


// WEBPACK FOOTER //
// ./src/components/settings/smslimit/SmsLimit.jsx